export default __webpack_public_path__ + "static/media/05-app-main.7a8757a6.PNG";